import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Avatar from '@mui/material/Avatar';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { checkPrivileges } from '../../Helpers';
import Style from 'style-it';

const checkUserType = (Utype) => {
  const typeMapping = {
    '-1': 'O',
    '1': 'U',
    '2': 'A',
    '3': 'AA',
    '4': 'SP',
    '5': 'R',
    '6': 'D',
  };
  return typeMapping[Utype] || 'U';
};

const Users = (props) => {
  const logInUser = useSelector((state) => state.logInUsers);

  return (
    <Style>
      {`
        .material-icons { vertical-align: middle; color: inherit; }
      `}
      <div>
        {props.users?.length > 0 && (
          <div className='individual-view'>
            <ul className='list-view'>
              {props.users.map((user) => (
                <ListRow
                  key={user.id}
                  data={user}
                  {...props}
                  logInUser={logInUser}
                  checkUserType={checkUserType} // Passing down the function as prop
                />
              ))}
            </ul>
          </div>
        )}
      </div>
    </Style>
  );
};

const ListRow = React.memo((props) => {
  const { data, selectedItemId, selecteItem, removedItem, editItem, logInUser, checkUserType, translate } = props;

  return (
    <li>
      <a
        href="#"
        className={`clearfix list-row ${selectedItemId === data.id ? 'active' : ''}`}
      >
        <label className='checkbox' onClick={() => selecteItem(data)}>
          <span className='unit-name' style={{ minWidth: 220, maxWidth: 220, marginLeft: 0 }}>
            <span style={{ marginRight: '10px', display: 'inline-block', verticalAlign: 'middle' }}>
              <Avatar
                className={`avatar-${checkUserType(data.userType)}`}
                style={{ width: 25, height: 25, fontSize: 12 }}
              >
                {checkUserType(data.userType)}
              </Avatar>
            </span>{' '}
            {data.name} {data.uniqueId}
          </span>
        </label>
        {logInUser.administrator && (
          <div className='pull-right'>
            {checkPrivileges('userDelete') && (
              <span
                className='action-item hovered'
                title={translate('delete')}
                onClick={() => removedItem(data)}
              >
                <DeleteIcon style={{ fontSize: 16 }} />
              </span>
            )}
            <span
              className='action-item hovered'
              title={translate('edit')}
              onClick={() => editItem(data)}
            >
              <EditIcon style={{ fontSize: 16 }} />
            </span>
          </div>
        )}
      </a>
    </li>
  );
});

const Users2 = (props) => {
  const logInUser = useSelector((state) => state.logInUsers);

  return (
    <Style>
      {`
        .material-icons { vertical-align: middle; color: inherit; }
      `}
      <div>
        {props.users?.length > 0 && (
          <div className='individual-view'>
            <ul className='list-view'>
              {props.users.map((user) => (
                <ListRow2
                  key={user.id}
                  data={user}
                  {...props}
                  logInUser={logInUser}
                  checkUserType={checkUserType}
                />
              ))}
            </ul>
          </div>
        )}
      </div>
    </Style>
  );
};

const ListRow2 = React.memo((props) => {
  const { data, removedItem, logInUser, checkUserType, translate } = props;

  return (
    <li>
      <Link
        to={`/users/${data.id}`}
        className={`clearfix list-row ${parseInt(props.match.params.id) === parseInt(data.id) ? 'active' : ''}`}
      >
        <label className='checkbox'>
          <span className='unit-name' style={{ minWidth: 220, maxWidth: 220, marginLeft: 0 }}>
            <span style={{ marginRight: '10px', display: 'inline-block', verticalAlign: 'middle' }}>
              <Avatar
                className={`avatar-${checkUserType(data.userType)}`}
                style={{ width: 18, height: 18, fontSize: 10 }}
              >
                {checkUserType(data.userType)}
              </Avatar>
            </span>{' '}
            {data.name} {data.uniqueId}
          </span>
        </label>
        {logInUser.administrator && checkPrivileges('userDelete') && props.data?.userCategory!==1&& (
          <div className='pull-right'>
            <span
              className='action-item'
              title={translate('delete')}
              onClick={() => removedItem(data)}
            >
              <DeleteIcon style={{ fontSize: 16 }} />
            </span>
          </div>
        )}
      </Link>
    </li>
  );
});
Users.displayName ="Users"
Users2.displayName ="Users2"
ListRow.displayName ="ListRow"
ListRow2.displayName ="ListRow2"





export const UsersShortList = Users;
export const UsersShortList2 = Users2;
